import Dinero from 'views/rebranded-module/common/utils/Dinero';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import { DEAL_TYPES } from 'views/common/utils/constants';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const useCalculateDealValue = () => {
  const content = useContent('DealCardComponent');
  const {
    DAILY_RATE,
    ONE_WAY_SPECIAL,
    BUY_ONE_DAY_GET_ONE,
    BUY_X_DAYS_GET_Y_DAYS,
    DISCOUNT_AMOUNT,
    TOUR,
    DISCOUNT_PERCENT,
    PACKAGE_PRICE,
    TOUR_WITH_OPERATIONAL_DAYS,
  } = DEAL_TYPES;

  const formatMoney = (priceObj) => moneyFormat(
    Dinero({
      amount: priceObj.amount,
      currency: priceObj.currency_code,
      precision: priceObj.precision,
    }),
  );

  const dealValue = (valueWC, discountedPrice, dealTypeSymId, options: { paid_days?: number, free_days?: number } = {}) => {
    const valueWcMoneyObj = formatMoney(valueWC);

    switch (dealTypeSymId) {
      case PACKAGE_PRICE:
        return {
          oldValue: valueWcMoneyObj,
          dealValue: formatMoney(discountedPrice),
        };

      case TOUR:
      case DISCOUNT_PERCENT:
      case TOUR_WITH_OPERATIONAL_DAYS:
        if (dealTypeSymId === DISCOUNT_PERCENT && +discountedPrice === 0) {
          return { dealValue: null };
        }
        return {
          dealValue: interpolateString(content.off, {
            value: +discountedPrice,
          }),
        };

      case DISCOUNT_AMOUNT:
        return {
          dealValue: interpolateString(content.offAmount, {
            value: formatMoney(discountedPrice),
          }),
        };

      case DAILY_RATE:
      case ONE_WAY_SPECIAL:
        return {
          oldValue: interpolateString(content.day, { value: valueWcMoneyObj }),
          dealValue: interpolateString(content.day, {
            value: formatMoney(discountedPrice),
          }),
        };

      case BUY_ONE_DAY_GET_ONE:
        return {
          dealValue: content.buyOneDayGetOneLabel,
        };

      case BUY_X_DAYS_GET_Y_DAYS: {
        const { paid_days, free_days } = options;
        const paidLabel = paid_days > 1 ? content.dealDayPlural : content.dealDaySingular;
        const freeLabel = free_days > 1 ? content.dealDayPlural : content.dealDaySingular;
        return {
          dealValue: interpolateString(content.buyXDaysGetYDaysFreeLabel, {
            paid_days,
            paid_day_label: paidLabel,
            free_days,
            free_day_label: freeLabel,
          }),
        };
      }

      default:
        return {};
    }
  };

  return dealValue;
};

export default useCalculateDealValue;
